module.exports = __webpack_public_path__ + "static/media/terms.836bbfed.md";